// export const apiUrl = '//localhost:8000/send.php';
// export const apiUrlForTranslate = '//localhost:8000/translate.php';
// export const apiUrl = '/wp-content/themes/fitintime/src/php/send.php';
export const urlPaymentTranslate = '/wp-content/themes/fitintime/build/php/payment-translate.php';
export const urlForKuwait = '/wp-content/themes/fitintime/build/php/translate-kuwait.php';
